import {DesktopDatePicker} from '@mui/x-date-pickers/DesktopDatePicker';
import {Dayjs} from 'dayjs';
import i18n from 'i18n';
import {DT_FORMATS} from 'utils';

export const DocumentDatePicker = ({
    value,
    onChange,
    flex,
}: {
    value: Dayjs | null;
    onChange: (date: Dayjs | null) => void;
    flex?: boolean;
}) => (
    <DesktopDatePicker
        label={i18n.t('docDate', {ns: 'common'})}
        value={value}
        onChange={onChange}
        format={DT_FORMATS.defaultDate}
        slotProps={{textField: {size: 'small', ...(flex && {sx: {flex: '1'}})}}}
    />
);
